
// ------ Basic functions --------------
// get service worker
export const getServiceWorkerRegistration = () => {
  return navigator.serviceWorker.getRegistration().then((registration) => {
    return registration;
  });
}